import { z } from "zod";
export const accountConfigSchema = z.object({ enabled: z.boolean() });
export const accountSessionSchema = z.object({
  user: z.object({ id: z.string().min(1), username: z.string().min(1), workspace_id: z.string().min(1), must_change_password: z.boolean() }),
  csrf_token: z.string().min(1),
});
export type AccountSession = z.infer<typeof accountSessionSchema>;
export const loginSchema = z.object({ username: z.string().trim().min(1).max(128), password: z.string().min(1).max(1024) });
export const passwordSchema = z.object({
  current_password: z.string().min(1).max(1024),
  new_password: z.string().refine((value) => {
    const bytes = new TextEncoder().encode(value).length;
    return Array.from(value).length >= 12 && bytes <= 1024;
  }),
  confirm_password: z.string(),
}).refine((value) => value.new_password === value.confirm_password, { path: ["confirm_password"] })
  .refine((value) => value.new_password !== value.current_password, { path: ["new_password"] });
